/**
 * i18n Configuration
 * 
 * Configures internationalization for the application using i18next. Sets up
 * translation file loading from backend, language detection from browser and
 * localStorage, and configures namespace management for organized translations.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'ar', 'ha'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: import.meta.env.MODE === 'development',

    interpolation: {
      escapeValue: false,
    },

    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'collections', 'disbursements', 'payroll', 'settings', 'invoicing', 'reports', 'sms', 'notifications', 'validation', 'utilities', 'wallet', 'settlements'],

    // Preload critical namespaces
    preload: ['en'],

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Load all namespaces in parallel
      allowMultiLoading: true,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;

